// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + ({"1587":"FeatureStrategyBuilderRoutes","2076":"common","8415":"GayaRoutes"}[chunkId] || chunkId) + "." + {"1587":"7959205da4ebc60e","2076":"c0dd6b69b3ba4c93","2960":"cd16b8640d836874","8415":"d65a4dad74068219"}[chunkId] + ".css";
};